import { SITE_CONFIG } from '../config';

// Reuse the existing LandingPage / Settings page-view contract. This records
// visits only, not contact clicks, inquiries, or qualified leads.
export function trackGuidePageView(pagePath) {
  const productionOrigin = `https://${SITE_CONFIG.BASE_URL.replace(/^https?:\/\//, '').replace(/\/$/, '')}`;
  if (window.location.origin !== productionOrigin) return;
  try {
    let sessionId = sessionStorage.getItem('session_id');
    if (!sessionId) {
      sessionId = Math.random().toString(36).slice(2, 11);
      sessionStorage.setItem('session_id', sessionId);
    }
    // Keep acquisition origin; exclude queries, fragments and referrer paths
    // that could contain a search, private conversation, or personal details.
    let referrer = '';
    try { if (document.referrer) referrer = new URL(document.referrer).origin; } catch { /* Optional. */ }
    fetch('https://tophamtechbeb.com/aw-monitor/v1/page-views', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        site_id: SITE_CONFIG.SITE_ID, page_path: pagePath, referrer,
        is_mobile: /Mobi|Android/i.test(navigator.userAgent),
        user_agent: navigator.userAgent, session_id: sessionId
      })
    }).catch(() => { /* Analytics must not block the guide. */ });
  } catch { /* Storage-disabled visitors can still read and contact. */ }
}
